<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :batch-actions="batchActions"
    :form="form"
    :title="$t('model.topic')"
    namespace=""
    resource="topics"
    :actionColumnProps="{ width: 240 }"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Topics extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [
      {
        prop: 'name_cont',
        label: this.$t('topic.name'),
        renderCell: {
          component: 'input'
        }
      },
      {
        prop: 'is_top_eq',
        label: this.$t('topic.isTop'),
        renderCell: {
          component: 'switch'
        }
      },
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'id',
        label: this.$t('id'),
        width: 80,
      },
      {
        prop: 'name',
        label: this.$t('topic.name'),
      },
      {
        prop: 'is_top',
        label: this.$t('topic.isTop'),
        renderCell: 'bool'
      },
    ];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'name',
        label: this.$t('topic.name'),
        renderCell: {
          component: 'input',
          required: true
        }
      }
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    const handleTop = async () => {
      await this.$autoLoading(this.$request.put(`/topics/${row.id}`, { is_top: !row.is_top }));
      this.$message.success(this.$t('bean.updateSuccess'));
      reload();
    }

    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'topics.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: `${row.is_top ? this.$t('bean.actionCancel') : ''}${this.$t('topic.isTop')}`,
          type: 'primary',
          can: 'topics.update'
        },
        on: {
          confirm: handleTop
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'topics.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  /**
   * @param {Object} scope -表格 scope 数据
   * @param {Object} scope.selection - 表格已选择行数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  batchActions() {
  // batchActions({ selection }, { remove, reload }) {
    return [
      // () => <el-button onClick={() => console.log(selection)}>批处理({ selection.length })</el-button>
    ];
  }

}


export const route = [
  {
    path: '/topics',
    name: 'topics.index',
    component: Topics,
    props: {
      type: 'index',
    }
  },
  {
    path: '/topics/new',
    name: 'topics.new',
    component: Topics,
    props: {
      type: 'new',
    }
  },
  {
    path: '/topics/:id',
    name: 'topics.show',
    component: Topics,
    props: {
      type: 'show',
    }
  },
  {
    path: '/topics/:id/edit',
    name: 'topics.edit',
    component: Topics,
    props: {
      type: 'edit'
    }
  }
]
</script>
